// L'avancement d'un travail de fond, de 0 à 1, sur TOUTE la tâche (issue #236).
//
// Le serveur dit l'étape en cours et son « X sur Y », dont l'unité change d'une
// étape à l'autre (sites relus, pages lues, offres classées, offres évaluées).
// Une barre par étape repartait de zéro à chaque changement : on croyait que ça
// reculait. Chaque étape prévue pèse ici une part égale de la barre.

export type EtapeTache = 'relecture' | 'lecture' | 'classement' | 'evaluation'

export function avancementTache(t: { phase: string; etapes?: readonly EtapeTache[]; fait: number; total: number }): number {
  const etapes = t.etapes ?? []
  const i = etapes.indexOf(t.phase as EtapeTache)
  const dansLEtape = t.total > 0 ? Math.min(1, Math.max(0, t.fait / t.total)) : 0
  // Une tâche d'avant ce champ, ou une étape non annoncée : l'étape seule.
  if (i < 0) return t.phase === 'attente' ? 0 : dansLEtape
  return (i + dansLEtape) / etapes.length
}
